// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { Component } from 'react'
import DataGrid, { Column } from 'react-data-grid'
import { withTranslation, WithTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import { ICustomerViewModel, IUnitViewModel } from '../../../types/interfaces'
import { LoadingSpinner } from '../../common/LoadingSpinner/LoadingSpinner'
import { ContactsKinds, ManagerKinds, ManagersContactsKinds } from '../../../types/enums'
import './CompanyWidget.scss'
import { unstable_runWithPriority } from 'scheduler'
import { Arr } from '../../../helpers/Arr'
import IdIsCopied from '../../../helpers/IdIsCopied'
import { Loader } from '../../common/Loader/Loader'

interface IAlertState {
  visible: boolean
  message: string
  title: string
}

interface ISortSettings {
  sortingEnabled?: boolean
  direction: number
  key: string
}

interface HeaderRendererProps {
  /** image url, used as background-image */
  title: string
  colKey: string
  sortSettings?: ISortSettings
  onSort?: (key: string) => void
  suffix?: () => void
}

interface IBreadCrumb {
  name: string
  id: string
}

interface IUnitGridProps extends WithTranslation, RouteComponentProps {
  onClose: () => void
  visible: boolean
  customer: ICustomerViewModel
  units: IUnitViewModel[]
}

interface IUnitGridState {
  gridSortingSettings: ISortSettings
  gridCols: Array<Column<IUnitGridRow>>
  gridRows: IUnitGridRow[]
  gridRowsToRender: IUnitGridRow[]
  copiedPopUpToggle: boolean
  idCopied: boolean
  searchString: string
  render: boolean
  height: number
  loading: boolean
  unitToDelete: null
  showDeleteConfirm: boolean
  deleteAlertState: {
    message: string
    title: string
    visible: boolean
  }
  breadCrumbs: []
  CCaddressExpand: number
  showModal: boolean
  selectedParentId: string
}

interface IUnitGridRow {
  rowNumber: number
  id: string
  reference: string
  addresses: string[]
  customerId: string
  parentId?: string
  numberOfChildren: number
  name: string
  email: string
  phoneNumber: string
  managerName: string
  note: string
}

enum UnitGridColumnKeyEnum {
  name = 'name',
  related = 'related',
  managerName = 'managerName',
  note = 'note',
  childUnits = 'childUnits',
  actions = 'actions',
}

class CopmanyWidgetUnits extends Component<IUnitGridProps, IUnitGridState> {
  constructor(props: IUnitGridProps) {
    super(props)
    this.generateGridCols = this.generateGridCols.bind(this)
    this.handleDocumentClick = this.handleDocumentClick.bind(this)
    this.state = {
      CCaddressExpand: null,
      gridCols: [],
      gridRows: [],
      gridRowsToRender: [],
      copiedPopUpToggle: false,
      idCopied: false,
      searchString: '',
      render: false,
      height: window.innerHeight,
      loading: false,
      unitToDelete: null,
      showDeleteConfirm: false,
      gridSortingSettings: {
        sortingEnabled: true,
        direction: 0,
        key: null,
      },
      deleteAlertState: {
        message: 'nothing',
        title: 'nothing',
        visible: false,
      },
      breadCrumbs: [],
      showModal: false,
      selectedParentId: '',
    }
  }

  public componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleDocumentClick, false)
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleDocumentClick)
    this.generateGridCols(this.state)
    this.generateUnitRows()
  }

  componentDidUpdate(oldProps: IUnitGridProps, oldState: IUnitGridState) {
    const { searchString } = this.state

    if (
      this.state.CCaddressExpand !== oldState.CCaddressExpand ||
      this.state.gridSortingSettings !== oldState.gridSortingSettings
    ) {
      this.generateGridCols(this.state)
    }

    if (this.state.idCopied !== oldState.idCopied) {
      if (this.state.idCopied) {
        setTimeout(() => {
          this.setState({
            idCopied: false,
          })
        }, 4000)
      } else {
        setTimeout(() => {
          this.setState({
            copiedPopUpToggle: false,
          })
        }, 500)
      }
    }
    if (this.state.gridSortingSettings !== oldState.gridSortingSettings) {
      this.sortGrid()
    }

    if (oldState.gridRows !== this.state.gridRows || searchString !== oldState.searchString) {
      this.generateCustomerRowsForRendering(searchString)
    }
  }

  render() {
    const { t } = this.props
    const { loading, searchString } = this.state

    return (
      <>
        <div className="popUnitsGridArea">
          <Loader blocking={loading}>
            <a onClick={this.props.onClose} className="closeBtn">
              <i className="icon-close"></i>
            </a>
            <div className="itemTitle">
              <div className="leftItemTitle" style={{ display: 'flex' }}>
                <i className="icon-units"></i>
                {t('COST_CENTER')} / {t('MANAGER')}
              </div>
              <div className="search-wrap">
                <input
                  autoFocus={true}
                  className="filterCompanies"
                  type="text"
                  name={`fieldnameveryunique${new Date().getTime()}`}
                  autoComplete="none"
                  list="autocompleteOff"
                  onChange={(e) => this.searchChanged(e)}
                  value={searchString}
                  placeholder={t('FILTER_UNIT_BY_KEYWORD')}
                />
                {this.state.searchString && (
                  <button title={t('CLEAR')} className="clr-btn" onClick={(e) => this.searchChanged()}>
                    <span className="icon-clear" />
                  </button>
                )}
                <i className="icon-search" />
              </div>
            </div>
            <div className="companiesToAssignGrid">
              <DataGrid
                className="rdg-light"
                columns={this.state.gridCols}
                rows={this.state.gridRowsToRender}
                rowHeight={45}
              />
            </div>
          </Loader>
          {this.state.copiedPopUpToggle && <IdIsCopied value={true} idCopied={this.state.idCopied} />}
        </div>
        <div className="blur"></div>
      </>
    )
  }

  private handleDocumentClick(e: any) {
    if (e?.target?.className !== 'icon-marker' && e?.target?.tagName !== 'LI' && e?.target?.tagName !== 'UL') {
      this.setState({
        CCaddressExpand: null,
      })
    }
  }

  sortGrid = () => {
    const { gridSortingSettings, gridRows } = this.state
    const sorted =
      gridSortingSettings.key && gridSortingSettings.direction !== 0
        ? gridRows.sort((a, b) => {
            const valA = a[gridSortingSettings.key]
            const valB = b[gridSortingSettings.key]
            return valA?.localeCompare(valB) * gridSortingSettings.direction
          })
        : gridRows.sort((a, b) => a.name.localeCompare(b.name))
    this.setState({
      gridRowsToRender: sorted,
    })
  }

  private generateCustomerRowsForRendering(search?: string) {
    const { gridRows } = this.state
    const gridRowsToRender = search
      ? gridRows.filter(
          (r) =>
            r.name?.toLowerCase().indexOf(search.toLowerCase()) >= 0 ||
            r.managerName?.toLowerCase().indexOf(search.toLowerCase()) >= 0 ||
            r.email?.toLowerCase().indexOf(search.toLowerCase()) >= 0 ||
            r.addresses?.find((a) => a?.toLowerCase().indexOf(search.toLowerCase()) >= 0)
        )
      : gridRows

    this.setState({
      gridRowsToRender,
    })
  }

  private searchChanged(event?: React.ChangeEvent<HTMLInputElement>, instant?: boolean) {
    const value = event ? event.currentTarget.value : ''
    this.setState({
      searchString: value,
    })
  }

  generateGridCols = (state: IUnitGridState) => {
    const { t } = this.props

    const copyCompanyID = (id: string) => {
      navigator.clipboard.writeText(id)
      this.setState({
        idCopied: true,
        copiedPopUpToggle: true,
      })
    }

    const rowAddressExpand = (id: number) => {
      if (state?.CCaddressExpand === id) {
        this.setState({
          CCaddressExpand: null,
        })
      } else {
        this.setState({
          CCaddressExpand: id,
        })
      }
    }

    const rawCols = [
      {
        key: UnitGridColumnKeyEnum.name,
        name: t('NAME'),
        width: 250,
        headerCellClass: 'general-contracts-header',
        renderHeaderCell: (p) => (
          <>
            {this.GridHeaderFormatter({
              title: t('NAME'),
              colKey: UnitGridColumnKeyEnum.name,
              onSort: this.handleSortingColumn,
              sortSettings: state?.gridSortingSettings,
            })}
          </>
        ),
        renderCell({ row }) {
          return (
            <div className="unitsCell">
              <i style={{ cursor: 'copy' }} onClick={(e) => copyCompanyID(row.id)} className="icon-id">
                {' '}
              </i>
              {row.name || t('NO_COST_CENTER')}
            </div>
          )
        },
      },
      {
        key: UnitGridColumnKeyEnum.note,
        name: t('NOTE'),
        width: 250,
        headerCellClass: 'general-contracts-header',
        renderHeaderCell: (p) => (
          <>
            {this.GridHeaderFormatter({
              title: t('NOTE'),
              colKey: UnitGridColumnKeyEnum.note,
              onSort: this.handleSortingColumn,
              sortSettings: state?.gridSortingSettings,
            })}
          </>
        ),
      },
      {
        key: UnitGridColumnKeyEnum.managerName,
        name: t('MANAGER'),
        headerCellClass: 'general-contracts-header',
        renderHeaderCell: (p) => (
          <>
            {this.GridHeaderFormatter({
              title: t('MANAGER'),
              colKey: UnitGridColumnKeyEnum.managerName,
              onSort: this.handleSortingColumn,
              sortSettings: state?.gridSortingSettings,
            })}
          </>
        ),
        renderCell({ row }) {
          return (
            <div className="managerCell">
              {row.managerName || t('NO_COST_CENTER')}
              <div className="managerIconArea">
                {/* {row.phoneNumber && ( */}
                <div className="managerIconParent">
                  <i
                    className={`icon-phone ${!row.phoneNumber ? 'disabled' : ''}`}
                    title={row.phoneNumber}
                    style={{ cursor: 'copy' }}
                    onClick={(e) => copyCompanyID(row.phoneNumber)}
                  />
                </div>

                {/* )} */}
                {/* {row.email && ( */}
                <div className="managerIconParent">
                  <i
                    className={`icon-mail ${!row.email ? 'disabled' : ''}`}
                    title={row.email}
                    style={{ cursor: 'copy' }}
                    onClick={(e) => copyCompanyID(row.email)}
                  />
                </div>

                {/* )} */}
                {/* {Arr.any(row.addresses) && ( */}
                <div className="addressArea">
                  {/* <div> */}
                  {row.addresses.length > 1 && <span>{row.addresses.length}</span>}
                  {/* </div> */}
                  <div className="managerIconParent" onClick={(e) => rowAddressExpand(row.rowNumber)}>
                    {/* <div > */} <i className={`icon-marker${!Arr.any(row.addresses) ? ' disabled' : ''}`}></i>
                  </div>

                  {state?.CCaddressExpand === row.rowNumber && (
                    <div className="tooltip">
                      <ul className="lastMile">
                        {row.addresses?.map((q) => (
                          <li>{q}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
                {/* )} */}
              </div>
            </div>
          )
        },
      },
    ]
    let gridCols = []
    gridCols = rawCols
    this.setState({
      gridCols,
    })
  }

  handleSortingColumn = (key: string) => {
    const { gridSortingSettings } = this.state

    const drections = {
      '1': -1,
      '-1': 0,
      '0': 1,
    }
    const direction = key === gridSortingSettings?.key ? drections[gridSortingSettings?.direction?.toString()] : 1
    this.setState({
      gridSortingSettings: {
        ...gridSortingSettings,
        direction,
        key,
      },
    })
  }

  private GridHeaderFormatter({ title, colKey, sortSettings, onSort }: HeaderRendererProps) {
    const sortDirection =
      sortSettings?.key !== colKey || sortSettings?.direction === 0 ? '0' : sortSettings?.direction.toString()
    const sortDirectionMap = {
      '1': '-up',
      '0': '',
      '-1': '-down',
    }
    return (
      <div className="rdg-header-cell-wrapper">
        <div
          className={`rdg-header-cell${' sortable'}`}
          onClick={() => {
            onSort(colKey)
          }}
        >
          <>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <span style={{ lineHeight: '17px' }}>{title}</span>
            </div>
            <i className={`icon-sort${sortDirectionMap[sortDirection]} sort`} />
          </>
        </div>
      </div>
    )
  }

  private generateUnitRows(newerSelectedParentId?: string) {
    const { t } = this.props
    const selectedParentId = newerSelectedParentId || this.state.selectedParentId
    const newRows: IUnitGridRow[] = []
    this.props.units.forEach((u, q) =>
      u.managers.forEach((m, i) => {
        const addresses: string[] = []
        m.addresses.map((q) => {
          addresses.push(`${q.street} ${q.postalCode} ${q.city} ${q.country}`)
        })
        m.kind === ManagerKinds.FleetManager &&
          newRows.push({
            rowNumber: Number('' + q + i),
            id: u.id,
            name: u.name,
            customerId: u.customerId,
            managerName: m.displayName,
            email: m.contacts.filter((q) => q.kind === ManagersContactsKinds.Email)[0]?.value || null,
            phoneNumber: m.contacts.filter((q) => q.kind === ManagersContactsKinds.PhoneNumber)[0]?.value || null,
            addresses: Array.from(new Set(addresses)),
            reference: u.reference,
            note: u.note,
            parentId: u.parentId,
            numberOfChildren: 0,
          })
      })
    )
    newRows.sort((a, b) => a.name.localeCompare(b.name))

    this.setState({
      gridRows: newRows,
    })
  }
}

export default withTranslation('common')(CopmanyWidgetUnits)
